import LoadingContent from "@/components/LoadingContent";
import { HorizontalFlex, LoaderSize } from "@enxcs/dap-ui-stratos";

export const FallbackScreen = () => {
  return (
    <HorizontalFlex $grow $justify="center" $align="center" style={{ height: "100vh" }}>
      <LoadingContent loaderSize={LoaderSize.V32} loaderHeight={LoaderSize.V56} loaderWidth={LoaderSize.V56} />
    </HorizontalFlex>
  );
};
